import { AttrInternalType, AttributeI } from '~src/interfaces/attributes.types';
import { PaginationI } from '~src/interfaces/pagination.interface';

export enum AttrSortingType {
  CreatedAsc = 'created',
  CreatedDesc = '-created',
}

export interface AttributesRespI {
  pagination: PaginationI;
  items: AttributeI[];
}

export interface AttributeAddI {
  attributeName: string;
  attributeType: AttrInternalType;
}

export interface AttrOptionAddRespI {
  value: { [key: string]: string };
  position: number;
  uuid: string;
}
